import { render } from "./CalendarUserShares.vue?vue&type=template&id=4c94c444&scoped=true"
import script from "./CalendarUserShares.vue?vue&type=script&lang=js"
export * from "./CalendarUserShares.vue?vue&type=script&lang=js"

import "./CalendarUserShares.vue?vue&type=style&index=0&id=4c94c444&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c94c444"]])

export default __exports__